var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    {
      staticClass: "padding-y-3xl",
      staticStyle: { "background-color": "var(--white)", overflow: "hidden" },
      attrs: { id: "hero" },
    },
    [
      _vm.isAffiliateReferral
        ? _c("affiliate-hero", { attrs: { affiliate: _vm.affiliate } })
        : _c("div", { staticClass: "container" }, [
            _c("div", { staticClass: "row roomy" }, [
              _c("div", { staticClass: "column-12" }, [
                _c("h1", [_vm._v("Here are the plans, Stan!")]),
                _vm._v(" "),
                _c(
                  "p",
                  { staticClass: "size-xl line-length-md" },
                  [
                    _vm._v(
                      "\n          We've got a Plan to get icons into any kind of project. Choose the one that works best for you and your team. Or\n          "
                    ),
                    _c("site-link", { attrs: { to: { name: "start" } } }, [
                      _vm._v("get started for Free"),
                    ]),
                    _vm._v("!\n        "),
                  ],
                  1
                ),
              ]),
            ]),
            _vm._v(" "),
            _vm.hasActiveOldPlan || _vm.hasNotOfferedPlan
              ? _c("div", { staticClass: "row roomy margin-top-xl" }, [
                  _c("div", { staticClass: "column-12" }, [
                    _vm.currentSubName === "Employee"
                      ? _c("div", { staticClass: "message info" }, [
                          _c(
                            "p",
                            {
                              staticStyle: { "--paragraph-margin-bottom": "0" },
                            },
                            [
                              _c("strong", { staticClass: "display-block" }, [
                                _vm._v(
                                  "You've got the " +
                                    _vm._s(_vm.currentSubName) +
                                    " plan!"
                                ),
                              ]),
                              _vm._v(" "),
                              _c("span", { staticClass: "display-block" }, [
                                _vm._v(
                                  'You know, you\'re a real straight-shooter with "upper management" written all over you.'
                                ),
                              ]),
                            ]
                          ),
                        ])
                      : _c("div", { staticClass: "message info" }, [
                          _c(
                            "p",
                            {
                              staticStyle: { "--paragraph-margin-bottom": "0" },
                            },
                            [
                              _c("strong", { staticClass: "display-block" }, [
                                _vm._v(
                                  "You've got the " +
                                    _vm._s(_vm.currentSubName) +
                                    " plan!"
                                ),
                              ]),
                              _vm._v(" "),
                              _c("span", { staticClass: "display-block" }, [
                                _vm._v(
                                  "We no longer offer your plan to new subscribers. You can switch to one of the new plans below, or\n              "
                                ),
                                _c(
                                  "a",
                                  {
                                    attrs: {
                                      href: "mailto:hello@fontawesome.com?subject=I have a question about my plan, Font Awesome!",
                                    },
                                  },
                                  [_vm._v("contact us")]
                                ),
                                _vm._v(" with questions."),
                              ]),
                            ]
                          ),
                        ]),
                  ]),
                ])
              : _vm._e(),
          ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }